export const sendEmail = (email: string, subject?: string, body?: string) => {
    const mail = document.createElement('a');

    mail.href = `mailto:${email}${subject || body ? '?' : ''}${subject ? `subject=${subject}` : ''}${
        body ? `body=${body}` : ''
    }`;
    mail.target = '_blank';
    mail.click();
};
